module.exports = __webpack_public_path__ + "static/media/DSCF0006.f948ad7f.jpg";